'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dagPb = require('@ipld/dag-pb');

var ipfsUnixfs = require('ipfs-unixfs');

var dir = require('./dir.js');

var persist = require('./utils/persist.js');

var DirFlat = /*#__PURE__*/function (_dir) {
  _inherits(DirFlat, _dir);

  var _super = _createSuper(DirFlat);

  function DirFlat(props, options) {
    var _this3;

    _classCallCheck(this, DirFlat);

    _this3 = _super.call(this, props, options);
    _this3._children = {};
    return _this3;
  }

  _createClass(DirFlat, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cid = undefined;
                this.size = undefined;
                this._children[name] = value;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function get(name) {
      return Promise.resolve(this._children[name]);
    }
  }, {
    key: "childCount",
    value: function childCount() {
      return Object.keys(this._children).length;
    }
  }, {
    key: "directChildrenCount",
    value: function directChildrenCount() {
      return this.childCount();
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._children[Object.keys(this._children)[0]];
    }
  }, {
    key: "eachChildSeries",
    value: function eachChildSeries() {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var keys, i, key;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                keys = Object.keys(_this._children);
                i = 0;

              case 2:
                if (!(i < keys.length)) {
                  _context2.next = 9;
                  break;
                }

                key = keys[i];
                _context2.next = 6;
                return {
                  key: key,
                  child: _this._children[key]
                };

              case 6:
                i++;
                _context2.next = 2;
                break;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "flush",
    value: function flush(block) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var children, links, i, child, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, unixfs, node, buffer, cid, size;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                children = Object.keys(_this2._children);
                links = [];
                i = 0;

              case 3:
                if (!(i < children.length)) {
                  _context3.next = 40;
                  break;
                }

                child = _this2._children[children[i]];

                if (!(child instanceof dir)) {
                  _context3.next = 36;
                  break;
                }

                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context3.prev = 8;
                _iterator = _asyncIterator(child.flush(block));

              case 10:
                _context3.next = 12;
                return _awaitAsyncGenerator(_iterator.next());

              case 12:
                if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                  _context3.next = 20;
                  break;
                }

                entry = _step.value;
                child = entry;
                _context3.next = 17;
                return child;

              case 17:
                _iteratorAbruptCompletion = false;
                _context3.next = 10;
                break;

              case 20:
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 26:
                _context3.prev = 26;
                _context3.prev = 27;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 31;
                return _awaitAsyncGenerator(_iterator.return());

              case 31:
                _context3.prev = 31;

                if (!_didIteratorError) {
                  _context3.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context3.finish(31);

              case 35:
                return _context3.finish(26);

              case 36:
                if (child.size != null && child.cid) {
                  links.push({
                    Name: children[i],
                    Tsize: child.size,
                    Hash: child.cid
                  });
                }

              case 37:
                i++;
                _context3.next = 3;
                break;

              case 40:
                unixfs = new ipfsUnixfs.UnixFS({
                  type: 'directory',
                  mtime: _this2.mtime,
                  mode: _this2.mode
                });
                node = {
                  Data: unixfs.marshal(),
                  Links: links
                };
                buffer = dagPb.encode(dagPb.prepare(node));
                _context3.next = 45;
                return _awaitAsyncGenerator(persist(buffer, block, _this2.options));

              case 45:
                cid = _context3.sent;
                size = buffer.length + node.Links.reduce(function (acc, curr) {
                  return acc + (curr.Tsize == null ? 0 : curr.Tsize);
                }, 0);
                _this2.cid = cid;
                _this2.size = size;
                _context3.next = 51;
                return {
                  cid: cid,
                  unixfs: unixfs,
                  path: _this2.path,
                  size: size
                };

              case 51:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[8, 22, 26, 36], [27,, 31, 35]]);
      }))();
    }
  }]);

  return DirFlat;
}(dir);

module.exports = DirFlat;